import "@aileron/icon";
import { unsafeCSS as y, LitElement as x, html as u } from "lit";
import { query as L, property as d } from "lit/decorators.js";
import { classMap as S } from "lit/directives/class-map.js";
const C = (i) => {
  class t extends i {
    constructor(...e) {
      super(...e), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const o = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(o.getElementsByTagName("link")).findIndex(
        (l) => l.href === this.fontLink
      ) === -1) {
        const l = document.createElement("link");
        l.href = this.fontLink, l.rel = "stylesheet", document.head.appendChild(l);
      }
    }
  }
  return t;
}, E = '*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}strong{font-weight:700;font-variation-settings:"wght" 700}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.pointer-events-none{pointer-events:none}.static{position:static}.mt-7{margin-top:1.75rem}.box-border{box-sizing:border-box}.inline{display:inline}.flex{display:flex}.table{display:table}.h-12{height:3rem}.h-9{height:2.25rem}.w-full{width:100%}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.items-center{align-items:center}.justify-center{justify-content:center}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.rounded{border-radius:.25rem}.border{border-width:1px}.border-solid{border-style:solid}.border-blue-060{border-color:#0860c4}.border-blue-070{border-color:#0a78f5}.border-blue-080{border-color:#3b93f7}.border-neutral-050{border-color:#405164}.border-neutral-090{border-color:#b4c1cf}.border-neutral-100{border-color:#e6eaef}.bg-blue-060{background-color:#0860c4}.bg-blue-070{background-color:#0a78f5}.bg-blue-080{background-color:#3b93f7}.bg-neutral-000{background-color:#101419}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-040{background-color:#303d4b}.bg-neutral-050{background-color:#405164}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-100{background-color:#e6eaef}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-neutral-140{background-color:#fff}.bg-transparent{background-color:transparent}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pl-4{padding-left:1rem}.pr-2{padding-right:.5rem}.pr-3{padding-right:.75rem}.pr-4{padding-right:1rem}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-base{font-size:1rem}.leading-6{line-height:1.5rem}.text-blue-060{color:#0860c4}.text-blue-080{color:#3b93f7}.text-neutral-000{color:#101419}.text-neutral-050{color:#405164}.text-neutral-090{color:#b4c1cf}.text-neutral-140{color:#fff}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.outline-neutral-100{outline-color:#e6eaef}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.font-bold{font-weight:700;font-variation-settings:"wght" 700}[hidden]{display:none!important}.hover\\:border-blue-070:hover{border-color:#0a78f5}.hover\\:border-neutral-100:hover{border-color:#e6eaef}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-neutral-100:hover{background-color:#e6eaef}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.hover\\:bg-transparent:hover{background-color:transparent}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-2:focus{outline-width:2px}.focus\\:outline-offset-2:focus{outline-offset:2px}.focus\\:outline-blue-070:focus{outline-color:#0a78f5}.focus\\:outline-neutral-100:focus{outline-color:#e6eaef}.active\\:border-blue-080:active{border-color:#3b93f7}.active\\:border-neutral-100:active{border-color:#e6eaef}.active\\:bg-blue-080:active{background-color:#3b93f7}.active\\:bg-neutral-100:active{background-color:#e6eaef}.active\\:bg-neutral-110:active{background-color:#eceff3}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.active\\:bg-neutral-130:active{background-color:#f9fafb}.active\\:bg-transparent:active{background-color:transparent}.active\\:outline:active{outline-style:solid}.active\\:outline-2:active{outline-width:2px}.active\\:outline-offset-2:active{outline-offset:2px}.active\\:outline-blue-070:active{outline-color:#0a78f5}.active\\:outline-neutral-100:active{outline-color:#e6eaef}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:cursor-default:disabled{cursor:default}.disabled\\:border-neutral-090:disabled{border-color:#b4c1cf}.disabled\\:text-neutral-090:disabled{color:#b4c1cf}.dark\\:border-blue-080:is(:host([aileron-color-scheme=dark]) *){border-color:#3b93f7}.dark\\:border-neutral-050:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:border-neutral-100:is(:host([aileron-color-scheme=dark]) *){border-color:#e6eaef}.dark\\:bg-blue-080:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:bg-neutral-000:is(:host([aileron-color-scheme=dark]) *){background-color:#101419}.dark\\:bg-neutral-050:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:bg-transparent:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:text-blue-080:is(:host([aileron-color-scheme=dark]) *){color:#3b93f7}.dark\\:text-neutral-000:is(:host([aileron-color-scheme=dark]) *){color:#101419}.dark\\:text-neutral-050:is(:host([aileron-color-scheme=dark]) *){color:#405164}.dark\\:text-neutral-140:is(:host([aileron-color-scheme=dark]) *){color:#fff}.dark\\:hover\\:bg-blue-070:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:hover\\:bg-neutral-010:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:hover\\:bg-neutral-020:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:hover\\:bg-neutral-030:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:hover\\:bg-transparent:hover:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:active\\:border-blue-060:active:is(:host([aileron-color-scheme=dark]) *){border-color:#0860c4}.dark\\:active\\:border-neutral-100:active:is(:host([aileron-color-scheme=dark]) *){border-color:#e6eaef}.dark\\:active\\:bg-blue-070:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:active\\:bg-neutral-010:active:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:active\\:bg-neutral-020:active:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:active\\:bg-neutral-030:active:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:active\\:bg-neutral-040:active:is(:host([aileron-color-scheme=dark]) *){background-color:#303d4b}.dark\\:active\\:bg-transparent:active:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:disabled\\:border-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:disabled\\:bg-transparent:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:disabled\\:text-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){color:#405164}', A = y(E), h = "aileron-color-scheme", w = "aileron-color-scheme-change", z = (i) => {
  const r = class r extends i {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (o) => {
        o.detail ? this.setAttribute(h, o.detail) : this.removeAttribute(h);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        w,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const o = document.documentElement.getAttribute(
        h
      );
      o && this.setAttribute(h, o);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        w,
        this.handleSchemeSwitch
      );
    }
  };
  r.styles = [
    A,
    i.styles ?? []
  ];
  let t = r;
  return t;
}, v = z(C(x));
function b(i, t) {
  function r(e) {
    if (!e || e === document || e === window)
      return null;
    e.assignedSlot && (e = e.assignedSlot);
    const o = e.closest(i);
    return o || r(e.getRootNode().host);
  }
  return r(t);
}
function f(i, t, r) {
  const e = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...r
  });
  return i.dispatchEvent(e), e;
}
class D extends Event {
  constructor(t) {
    super("formdata"), this.formData = t;
  }
}
class F extends FormData {
  constructor(t) {
    super(t), this.form = t, t.dispatchEvent(new D(this));
  }
  append(t, r) {
    let e = this.form.elements[t];
    if (e || (e = document.createElement("input"), e.type = "hidden", e.name = t, this.form.appendChild(e)), this.has(t)) {
      const o = this.getAll(t), a = o.indexOf(e.value);
      a !== -1 && o.splice(a, 1), o.push(r), this.set(t, o);
    } else
      super.append(t, r);
    e.value = r;
  }
}
function N() {
  const i = document.createElement("form");
  let t = !1;
  return document.body.append(i), i.addEventListener("submit", (r) => {
    new FormData(r.target), r.preventDefault();
  }), i.addEventListener("formdata", () => t = !0), i.dispatchEvent(new Event("submit", { cancelable: !0 })), i.remove(), t;
}
function k() {
  !window.FormData || N() || (window.FormData = F, window.addEventListener("submit", (i) => {
    i.defaultPrevented || new FormData(i.target);
  }));
}
document.readyState === "complete" ? k() : window.addEventListener("DOMContentLoaded", () => k());
class T {
  constructor(t, r) {
    (this.host = t).addController(this), this.options = {
      form: (e) => b("form", e),
      name: (e) => e.name,
      value: (e) => e.value,
      disabled: (e) => e.disabled,
      reportValidity: (e) => typeof e.reportValidity == "function" ? e.reportValidity() : !0,
      ...r
    }, this.options.form(this.host) && (this.options.form(this.host).noValidate = !0), this.handleFormData = this.handleFormData.bind(this), this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  hostConnected() {
    var t;
    this.form = (t = this.options) == null ? void 0 : t.form(this.host), this.form && (this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit));
  }
  hostDisconnected() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form = void 0);
  }
  handleFormData(t) {
    const r = this.options.disabled(this.host), e = this.options.name(this.host), o = this.options.value(this.host);
    !r && typeof e == "string" && typeof o < "u" && (Array.isArray(o) ? o.forEach((a) => {
      t.formData.append(e, a.toString());
    }) : t.formData.append(e, o.toString()));
  }
  handleFormSubmit(t) {
    const r = this.options.disabled(this.host);
    this.form && !r && (t.preventDefault(), t.stopImmediatePropagation());
  }
  submit(t) {
    if (this.form) {
      const r = document.createElement("button");
      r.type = "submit", r.style.position = "absolute", r.style.width = "0", r.style.height = "0", r.style.clipPath = "inset(50%)", r.style.overflow = "hidden", r.style.whiteSpace = "nowrap", t && ["formaction", "formmethod", "formnovalidate", "formtarget"].forEach((e) => {
        t.hasAttribute(e) && r.setAttribute(e, t.getAttribute(e));
      }), this.form.append(r), r.click(), r.remove();
    }
  }
}
class $ {
  constructor(t) {
    this.userAgent = t;
  }
  getDevice() {
    return this.userAgent.match(/iPad/i) ? "iPad" : this.userAgent.match(/iPhone/i) ? "iPhone" : this.userAgent.match(/iPod/i) ? "iPod" : this.userAgent.match(/Android/i) ? "Android" : "Unknown";
  }
  getBrowser() {
    return this.userAgent.match(/chrome|chromium|crios/i) ? "Chrome" : this.userAgent.match(/firefox|fxios/i) ? "Firefox" : this.userAgent.match(/opr\//i) ? "Opera" : this.userAgent.match(/edg/i) ? "Edge" : this.userAgent.match(/safari/i) ? "Safari" : "Unknown";
  }
}
class I {
  constructor(t, ...r) {
    this.slotNames = [], (this.host = t).addController(this), this.slotNames = r, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => {
      var r;
      if (t.nodeType === t.TEXT_NODE && ((r = t.textContent) == null ? void 0 : r.trim()) !== "")
        return !0;
      if (t.nodeType === t.ELEMENT_NODE) {
        const e = t;
        if (e.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!e.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(t) {
    return this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    var e, o;
    const r = t.target;
    ((e = this.slotNames) != null && e.includes("[default]") && !r.name || r.name && ((o = this.slotNames) != null && o.includes(r.name))) && this.host.requestUpdate();
  }
}
const U = ':host{display:inline-flex}:host([size~="fullwidth"]){display:flex}';
function O(i, t) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (e, o) => {
    const { update: a } = e;
    if (i in e) {
      const c = i;
      e.update = function(l) {
        if (l.has(c)) {
          const m = l.get(c), p = this[c];
          m !== p && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            m,
            p
          );
        }
        a.call(this, l);
      };
    }
  };
}
var M = Object.defineProperty, B = Object.getOwnPropertyDescriptor, s = (i, t, r, e) => {
  for (var o = e > 1 ? void 0 : e ? B(t, r) : t, a = i.length - 1, c; a >= 0; a--)
    (c = i[a]) && (o = (e ? c(t, r, o) : c(o)) || o);
  return e && o && M(t, r, o), o;
};
const R = {
  PRIMARY: "primary",
  PRIMARY_INVERSE: "primaryInverse",
  SECONDARY: "secondary",
  SECONDARY_INVERSE: "secondaryInverse",
  GHOST: "ghost"
}, P = {
  SMALL: "sm",
  FIELD: "field",
  FULLWIDTH: "fullwidth",
  SMALL_FULLWIDTH: "sm fullwidth",
  DEFAULT: ""
}, _ = {
  BUTTON: "button",
  SUBMIT: "submit",
  RESET: "reset",
  MENU: "menu"
}, g = class g extends v {
  constructor() {
    super(...arguments), this.hasSlotController = new I(
      this,
      "leading-icon",
      "trailing-icon"
    ), this.formSubmitController = new T(this, {
      form: (t) => {
        if (t.hasAttribute("form")) {
          const r = t.getRootNode(), e = t.getAttribute("form");
          return r.getElementById(e);
        }
        return t.closest("form");
      }
    }), this.autofocus = !1, this.disabled = !1, this.labelText = "", this.kind = R.PRIMARY, this.size = P.DEFAULT, this.type = _.BUTTON, this.href = "", this.isLoading = !1, this.target = "";
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-button");
  }
  /**
   * @ignore
   */
  click() {
    this.isLoading || this.buttonNode.click();
  }
  /**
   * @ignore
   */
  focus(t) {
    this.buttonNode.focus(t);
  }
  /**
   * @ignore
   */
  blur() {
    this.buttonNode.blur();
  }
  /**
   * @ignore
   */
  handleBlur() {
    f(this, "adc-blur");
  }
  /**
   * @ignore
   */
  handleFocus() {
    f(this, "adc-focus");
  }
  handleIsLoadingChanged() {
    const t = this.getBoundingClientRect().width;
    this.isLoading ? this.buttonNode.style.width = `${t}px` : this.buttonNode && (this.buttonNode.style.width = "");
  }
  /**
   * @ignore
   */
  firstUpdated() {
    const t = new $(navigator.userAgent);
    this.browser = t.getBrowser().toLowerCase();
  }
  /**
   * @ignore
   * @fires click - listens for a click event on the button.
   */
  handleClick() {
    this.isLoading || (this.type === "submit" && this.formSubmitController.submit(this), this.browser === "safari" && this.focus(), f(this, "adc-click"));
  }
  getClassMap() {
    const t = {
      "appearance-none": !0,
      "cursor-pointer": !this.isLoading,
      flex: !0,
      "items-center": !0,
      "justify-center": !0,
      "gap-3": !this.size.includes("sm"),
      "gap-2": this.size.includes("sm"),
      "h-12": !this.size.includes("sm"),
      "h-9": this.size.includes("sm"),
      "w-full": this.size.includes("fullwidth"),
      "mt-7": this.size.includes("field"),
      "pl-3": this.hasSlotController.test("leading-icon") && !this.size.includes("sm") || !this.hasSlotController.test("leading-icon") && this.size.includes("sm"),
      "pr-4": !this.hasSlotController.test("trailing-icon") && !this.size.includes("sm"),
      "pr-3": this.hasSlotController.test("trailing-icon") && !this.size.includes("sm") || !this.hasSlotController.test("trailing-icon") && this.size.includes("sm"),
      "pl-4": !this.hasSlotController.test("leading-icon") && !this.size.includes("sm"),
      "pl-2": this.hasSlotController.test("leading-icon") && this.size.includes("sm"),
      "pr-2": this.hasSlotController.test("trailing-icon") && this.size.includes("sm"),
      rounded: !0,
      "text-base": !0,
      "font-sans": !0,
      "font-bold": !0,
      "leading-6": !0,
      "box-border": !0,
      "adc-button--has-only-icon": (this.hasSlotController.test("leading-icon") || this.hasSlotController.test("trailing-icon")) && !this.hasSlotController.test("[default]"),
      "adc-button--has-trailing-icon": this.hasSlotController.test("trailing-icon"),
      "adc-button--has-leading-icon": this.hasSlotController.test("leading-icon"),
      //Base Outline styles
      "active:outline": !0,
      "active:outline-2": !0,
      "active:outline-offset-2": !0,
      "active:outline-blue-070": !0,
      "focus:outline": !0,
      "focus:outline-2": !0,
      "focus:outline-offset-2": !0,
      "focus:outline-blue-070": !0,
      //Base Disabled styles
      "disabled:cursor-default": !0,
      "disabled:pointer-events-none": !0,
      "cursor-default": this.disabled || this.isLoading,
      "pointer-events-none": this.disabled
    }, r = !!b(".container-secondary", this), e = !!b(".container-tertiary", this), o = !!b(".container-default", this) || !r && !e;
    let a = {};
    switch (this.kind) {
      case "primary":
        a = {
          //Primary text styles
          "text-neutral-140": !0,
          "dark:text-neutral-000": !0,
          //Primary background styles
          "bg-blue-060": !0,
          "dark:bg-blue-080": !0,
          "hover:bg-blue-070": !this.isLoading,
          "dark:hover:bg-blue-070": !this.isLoading,
          "active:bg-blue-080": !this.isLoading,
          "dark:active:bg-blue-070": !this.isLoading,
          //Primary Disabled styles
          "bg-neutral-090": this.disabled,
          "dark:bg-neutral-050": this.disabled
        };
        break;
      case "primaryInverse":
        a = {
          //Primary text styles
          "text-blue-060": !0,
          "dark:text-neutral-140": !0,
          //Primary background styles
          "bg-neutral-140": !0,
          "dark:bg-neutral-000": !0,
          "hover:bg-neutral-120": o,
          "hover:bg-neutral-110": r,
          "hover:bg-neutral-100": e,
          "dark:hover:bg-neutral-010": !0,
          "active:bg-neutral-130": !0,
          "dark:active:bg-neutral-010": !0,
          //Primary Disabled styles
          "text-neutral-140": this.disabled,
          "dark:text-neutral-000": this.disabled,
          "bg-neutral-090": this.disabled,
          "dark:bg-neutral-050": this.disabled
        };
        break;
      case "secondary":
        a = {
          //Secondary text styles
          "text-blue-060": !0,
          "dark:text-blue-080": !0,
          //Secondary background styles
          "bg-transparent": !0,
          "dark:bg-transparent": !0,
          "hover:bg-neutral-130": o && !this.isLoading,
          "dark:hover:bg-neutral-010": o && !this.isLoading,
          "active:bg-neutral-120": o && !this.isLoading,
          "dark:active:bg-neutral-020": o && !this.isLoading,
          "hover:bg-neutral-120": r && !this.isLoading,
          "dark:hover:bg-neutral-020": r && !this.isLoading,
          "active:bg-neutral-110": r && !this.isLoading,
          "dark:active:bg-neutral-030": r && !this.isLoading,
          "hover:bg-neutral-110": e && !this.isLoading,
          "dark:hover:bg-neutral-030": e && !this.isLoading,
          "active:bg-neutral-100": e && !this.isLoading,
          "dark:active:bg-neutral-040": e && !this.isLoading,
          //Secondary disabled styles
          "text-neutral-090": this.disabled,
          "dark:text-neutral-050": this.disabled,
          "border-neutral-090": this.disabled,
          "dark:border-neutral-050": this.disabled,
          //Secondary border styles
          border: !0,
          "border-solid": !0,
          "border-blue-060": !0,
          "dark:border-blue-080": !0,
          "hover:border-blue-070": !this.isLoading,
          //Dark also
          "active:border-blue-080": !this.isLoading,
          "dark:active:border-blue-060": !this.isLoading
        };
        break;
      case "secondaryInverse":
        a = {
          //Secondary text styles
          "text-neutral-140": !0,
          //Secondary background styles
          "bg-transparent": !0,
          "hover:bg-transparent": !0,
          "dark:hover:bg-transparent": !0,
          "active:bg-transparent": !0,
          "dark:active:bg-transparent": !0,
          //Secondary disabled styles
          "disabled:text-neutral-090": !0,
          "dark:disabled:text-neutral-050": !0,
          "dark:disabled:bg-transparent": !0,
          "disabled:border-neutral-090": !0,
          "dark:disabled:border-neutral-050": !0,
          //Secondary border styles
          border: !0,
          "border-solid": !0,
          "border-neutral-100": !0,
          "dark:border-neutral-100": !0,
          "hover:border-neutral-100": !0,
          //Dark also
          "active:border-neutral-100": !0,
          "dark:active:border-neutral-100": !0,
          //Base Outline styles
          "active:outline": !0,
          "active:outline-2": !0,
          "active:outline-offset-2": !0,
          "active:outline-neutral-100": !0,
          "focus:outline": !0,
          "focus:outline-2": !0,
          "focus:outline-offset-2": !0,
          "focus:outline-neutral-100": !0
        };
        break;
      case "ghost":
        a = {
          //Ghost text styles
          "text-blue-060": !0,
          "dark:text-blue-080": !0,
          //Ghost background styles
          "bg-transparent": !0,
          "dark:bg-transparent": !0,
          "hover:bg-neutral-130": o && !this.isLoading,
          "dark:hover:bg-neutral-010": o && !this.isLoading,
          "active:bg-neutral-120": o && !this.isLoading,
          "dark:active:bg-neutral-020": o && !this.isLoading,
          "hover:bg-neutral-120": r && !this.isLoading,
          "dark:hover:bg-neutral-020": r && !this.isLoading,
          "active:bg-neutral-110": r && !this.isLoading,
          "dark:active:bg-neutral-030": r && !this.isLoading,
          "hover:bg-neutral-110": e && !this.isLoading,
          "dark:hover:bg-neutral-030": e && !this.isLoading,
          "active:bg-neutral-100": e && !this.isLoading,
          "dark:active:bg-neutral-040": e && !this.isLoading,
          //Ghost disabled styles
          "text-neutral-090": this.disabled,
          "dark:text-neutral-050": this.disabled
          //No border
        };
        break;
    }
    return S(Object.assign(t, a));
  }
  render() {
    return this.href === "" ? u`<button
        id="button"
        part="interactive"
        class="adc-button ${this.getClassMap()}"
        ?autofocus=${this.autofocus}
        ?disabled=${this.disabled}
        aria-disabled=${this.disabled ? "true" : "false"}
        type=${this.type}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        ${this.isLoading ? u`<adc-icon icon="action:loader" size="24"></adc-icon>` : u` <slot name="leading-icon"></slot>
              <slot>${this.labelText}</slot>
              <slot name="trailing-icon"></slot>`}
      </button>` : u`
      <a
        id="button"
        part="interactive"
        class="adc-button ${this.getClassMap()}"
        ?autofocus=${this.autofocus}
        ?disabled=${this.disabled}
        aria-disabled=${this.disabled ? "true" : "false"}
        type=${this.type}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
        href="${this.href}"
        target="${this.target}"
      >
        <slot name="leading-icon"></slot>
        <slot>${this.labelText}</slot>
        <slot name="trailing-icon"></slot>
      </a>
    `;
  }
  updated(t) {
    super.updated(t), t.has("disabled") && (this.disabled ? this.buttonNode.setAttribute("disabled", "disabled") : this.buttonNode.removeAttribute("disabled"));
  }
};
g.styles = [v.styles || [], y(U)];
let n = g;
s([
  L("#button")
], n.prototype, "buttonNode", 2);
s([
  d({ type: Boolean, reflect: !0 })
], n.prototype, "autofocus", 2);
s([
  d({ type: Boolean, reflect: !0 })
], n.prototype, "disabled", 2);
s([
  d({ attribute: "label-text" })
], n.prototype, "labelText", 2);
s([
  d({ reflect: !0 })
], n.prototype, "kind", 2);
s([
  d({ reflect: !0 })
], n.prototype, "size", 2);
s([
  d({ reflect: !0 })
], n.prototype, "type", 2);
s([
  d({ reflect: !0 })
], n.prototype, "href", 2);
s([
  d({ type: Boolean, reflect: !0, attribute: "is-loading" })
], n.prototype, "isLoading", 2);
s([
  d({ reflect: !0 })
], n.prototype, "target", 2);
s([
  O("isLoading")
], n.prototype, "handleIsLoadingChanged", 1);
try {
  customElements.define("adc-button", n);
} catch {
}
function V(i) {
  try {
    customElements.define(`${i}-button`, class extends n {
    });
  } catch {
  }
}
function K(i) {
  try {
    V(i);
  } catch {
  }
}
export {
  R as BUTTON_KIND,
  P as BUTTON_SIZE,
  _ as BUTTON_TYPE,
  n as Button,
  V as registerButton,
  K as registerComponent
};
